import React, { useState } from "react";
import dayjs from "dayjs";

// core
import { API } from "../../core/api";
import {
  addTomanPriceComma,
  addPriceComma,
  removePriceComma,
} from "../../core/utils";

// components
// import { DatePicker as DatePickerJalali } from "antd-jalali";
import { DateRangePicker as DatePickerJalali } from "react-advance-jalaali-datepicker";
import { Form, Input, Select, Switch, Button, Divider, Collapse } from "antd";
import { Loading } from "../../components/Loading";
import { IsActive } from "../../components/IsActive";
import { Note } from "../Note";

const { Option } = Select;
const { Panel } = Collapse;

export const SellerProduct = (props) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [sellerProduct, setSellerProduct] = useState(props.sellerProduct);
  const [unlimitedStock, setUnlimitedStock] = useState(
    props.sellerProduct.unlimited_stock
  );
  const [visibleDiscountType, setVisibleDiscountType] = useState(
    props.sellerProduct.visible_discount_type
  );

  const updateProduct = (values) => {
    values = {
      ...values,
      discount_amount: removePriceComma(values.discount_amount),
      price: removePriceComma(values.price),
      stock: removePriceComma(values.stock),
      release_date: values.release_date
        ? values.release_date.format("YYYY-MM-DD HH:mm")
        : null,
      expire_date: values.expire_date
        ? values.expire_date.format("YYYY-MM-DD HH:mm")
        : null,
    };

    setIsLoading(true);
    // API.put
    //   .seller_product(sellerProduct.id, values)
    //   .then((response) => {
    //     if (response.success) {
    //       setSellerProduct(response.data);
    //       setUnlimitedStock(response.data.unlimited_stock);
    //       setVisibleDiscountType(response.data.visible_discount_type);
    //       form.setFieldsValue({
    //         discount_amount: addPriceComma(response.data.discount_amount),
    //       });
    //       form.setFieldsValue({
    //         price: addPriceComma(response.data.price),
    //       });
    //       form.setFieldsValue({
    //         stock: addPriceComma(response.data.stock),
    //       });

    //       Note.success(response.message);
    //       setIsLoading(false);
    //     } else {
    //       Note.error(response.message);
    //       setIsLoading(false);
    //     }
    //   })
    //   .catch((e) => {
    //     console.log(e);
    //     setIsLoading(false);
    //   });
  };

  return (
    <div className="seller-product">
      <Loading isLoading={isLoading}>
        <Form
          form={form}
          name="sellerProductForm"
          onFinish={updateProduct}
          initialValues={{
            is_active: sellerProduct.is_active,
            stock: sellerProduct.stock,
            unlimited_stock: sellerProduct.unlimited_stock,
            price: addPriceComma(sellerProduct.price),
            discount_amount: addPriceComma(sellerProduct.discount_amount),
            discount_type: sellerProduct.discount_type,
            visible_discount_type: sellerProduct.visible_discount_type,
            release_date: sellerProduct.release_date
              ? dayjs(sellerProduct.release_date)
              : null,
            expire_date: sellerProduct.expire_date
              ? dayjs(sellerProduct.expire_date)
              : null,
          }}
          requiredMark={false}
          scrollToFirstError
        >
          <Collapse ghost>
            <Panel
              showArrow={false}
              key={sellerProduct.id}
              header={
                <div className="flex-row flex-content-space-between flex-items-center w-100">
                  <div className="flex-row flex-items-center flex-wrap w-50">
                    <IsActive value={sellerProduct.is_active} />
                    <small className="color-promotion-s1 mr-10 ml-5">
                      [{sellerProduct.city.province.name}]
                    </small>
                    <span className="mx-10">{sellerProduct.city.name}</span>
                    <small>[{sellerProduct.id}]</small>
                    <small className="mx-10 color-orange">
                      فروشنده {sellerProduct.seller.name}
                    </small>
                  </div>
                  <div className="flex-row flex-items-center flex-wrap flex-content-end w-50">
                    <span>
                      {sellerProduct.is_buyable ? (
                        <small className="bg-color-promotion color-white border-radius-pill px-10">
                          قابل خرید
                        </small>
                      ) : (
                        <small className="bg-color-red color-white border-radius-pill px-10">
                          غیر قابل خرید
                        </small>
                      )}
                    </span>
                    <span className="mr-20">
                      {addTomanPriceComma(sellerProduct.payable_amount)} تومان
                    </span>
                  </div>
                </div>
              }
            >
              <div className="flex-row flex-content-space-between flex-wrap">
                <Form.Item
                  className="min-w-250px w-30 sm:w-100 pt-10"
                  name="discount_amount"
                  label="تخفیف"
                  colon={false}
                  onChange={(e) =>
                    form.setFieldsValue({
                      discount_amount: addPriceComma(e.target.value),
                    })
                  }
                  rules={[
                    {
                      required: true,
                      message:
                        "تخفیف کالا الزامی است. مقدار ۰ را برای کالاهایی که تخفیف ندارند وارد کنید.",
                    },
                  ]}
                >
                  <Input
                    className="input-black border-black text-left"
                    addonAfter={
                      <Form.Item name="discount_type" noStyle>
                        <Select>
                          <Option value="fixed">ریال</Option>
                          <Option value="percentage">درصد</Option>
                        </Select>
                      </Form.Item>
                    }
                  />
                </Form.Item>
                <Form.Item
                  className="min-w-250px w-30 sm:w-100 pt-10"
                  name="price"
                  label="قیمت"
                  colon={false}
                  onChange={(e) =>
                    form.setFieldsValue({
                      price: addPriceComma(e.target.value),
                    })
                  }
                  rules={[{ required: true, message: "قیمت کالا الزامی است." }]}
                >
                  <Input
                    className="input-black border-black text-left"
                    suffix="ریال"
                  />
                </Form.Item>
                <Form.Item
                  className="pt-10"
                  name="is_active"
                  valuePropName="checked"
                  colon={false}
                >
                  <Switch checkedChildren="فعال" unCheckedChildren="غیرفعال" />
                </Form.Item>
              </div>
              <div className="flex-row flex-content-space-between flex-wrap">
                <div className="flex-row flex-items-center sm:w-100 pt-10 w-25">
                  <Form.Item
                    className="sm:w-60"
                    name="visible_discount_type"
                    label="نوع نمایش تخفیف"
                    colon={false}
                    rules={[
                      {
                        required: true,
                        message: "نوع نمایش تخفیف کالا الزامی است.",
                      },
                    ]}
                  >
                    <Select
                      className="border-black"
                      onChange={(value) => {
                        setVisibleDiscountType(value);
                      }}
                    >
                      <Option value="fixed">تومان</Option>
                      <Option value="percentage">درصد</Option>
                    </Select>
                  </Form.Item>
                  <div className="pr-20 sm:w-40 text-center">
                    {visibleDiscountType === "fixed" ? (
                      <span>
                        {addTomanPriceComma(
                          sellerProduct.fixed_discount_amount
                        )}{" "}
                        تومان
                      </span>
                    ) : (
                      <span>{sellerProduct.discount_percentage} %</span>
                    )}
                  </div>
                </div>
                <Form.Item
                  className="sm:w-100 pt-10 w-30"
                  name="stock"
                  label="موجودی"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message:
                        "موجودی کالا الزامی است. مقدار ۰ را برای کالاهایی که موجودی ندارند وارد کنید.",
                    },
                  ]}
                >
                  <Input
                    className={`${
                      unlimitedStock && "hidden-input"
                    } input-black border-black text-left`}
                    disabled={unlimitedStock}
                    suffix={unlimitedStock ? "" : props.unit}
                    onChange={(e) =>
                      form.setFieldsValue({
                        stock: addPriceComma(e.target.value),
                      })
                    }
                    addonBefore={
                      <Form.Item name="unlimited_stock" noStyle>
                        <Select
                          onChange={(value) => {
                            setUnlimitedStock(value);
                          }}
                        >
                          <Option value={true}>نامحدود</Option>
                          <Option value={false}>محدود</Option>
                        </Select>
                      </Form.Item>
                    }
                  />
                </Form.Item>
                <div></div>
              </div>
              <div className="flex-row flex-content-space-between flex-wrap">
                <Form.Item
                  className="min-w-250px w-30 sm:w-100 pt-10"
                  name="release_date"
                  label="تاریخ انتشار"
                  colon={false}
                >
                  <DatePickerJalali
                    className="input-black border-black w-100"
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>
                <Form.Item
                  className="min-w-250px w-30 sm:w-100 pt-10"
                  name="expire_date"
                  label="تاریخ انقضا"
                  colon={false}
                >
                  <DatePickerJalali
                    className="input-black border-black w-100"
                    showTime={{ format: "HH:mm" }}
                    format="YYYY-MM-DD HH:mm"
                  />
                </Form.Item>
                <Form.Item className="pt-10 sm:w-100">
                  <Button
                    className="button-promotion sm:w-100"
                    htmlType="submit"
                  >
                    ذخیره
                  </Button>
                </Form.Item>
              </div>
            </Panel>
          </Collapse>
        </Form>
      </Loading>
      <Divider />
    </div>
  );
};
